import { foundations } from '../foundations';
const { colors, shadows } = foundations;

export const Menu = {
  baseStyle: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
    list: {
      boxShadow: shadows.xl,
      border: `1px solid ${colors.border.transparent[colorMode]}`,
      bg: colors.background.container[colorMode],
      py: '0.25rem',
    },
    item: {
      bg: 'inherit',
      py: '0.375rem',
      my: '0',
      color: colors.text.base[colorMode],
      fontSize: '0.875rem',
      pl: '0.875rem',
      pr: '1.25rem',
      _hover: {
        bg: colors.interactive.hover[colorMode],
      },
      _focus: {
        bg: colors.interactive.hover[colorMode],
      },
      _active: {
        bg: colors.interactive.pressed[colorMode],
      },
      svg: {
        height: '0.875rem',
        width: '0.875rem',
        color: colors.icon.default,
      },
    },
    groupTitle: {
      textAlign: 'left',
      color: colors.text.secondary[colorMode],
      textTransform: 'none',
      margin: '0.5rem 0.875rem 0.25rem',
      fontWeight: '600',
      fontSize: '0.75rem',
    },
    command: {
      textStyle: 'caption',
      color: colors.text.secondary[colorMode],
    },
    divider: {
      borderBottom: `1px solid ${colors.border.transparent[colorMode]}`,
      my: '0.25rem',
    },
  }),
};
